import { render, staticRenderFns } from "./PartnerDocumentBrowser.vue?vue&type=template&id=2c10a0b1&"
import script from "./PartnerDocumentBrowser.vue?vue&type=script&lang=ts&"
export * from "./PartnerDocumentBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports